<form [formGroup]="formData" *ngIf="formData">

  <div class="ui-g form-group master-data">
    <div [kv-form-element]="{ label: ('customerDetail.hobbies') , md: '12'}"></div>

    <div [kv-form-element]="{ label: 'customerDetail.hobby_' + (i + 1), md: '3', sm: '6' }" *ngFor="let item of evaluateLength(12); let i = index">
      <p-inputSwitch [formControlName]="evaluateFormControlName('flag_hobby', i)">
      </p-inputSwitch>
    </div>

    <div class="ui-g-12"><hr /></div>
    <div [kv-form-element]="{ label: ('customerDetail.pets') , md: '12'}"></div>

    <div class="ui-g-6" *ngFor="let item of [1,2,3,4]; let i = index" [hidden]="">
      <div class="ui-g-6">
        <div [kv-form-element]="{ label: ('customerDetail.pet_' + (i + 1)) , md: '12'}"></div>
      </div>
      <div class="ui-g-6">
        <input type="number" min="0" pInputText [formControlName]="evaluateFormControlName('pet', i)" placeholder="0"/>
      </div>
    </div>

    <div class="ui-g-6">
      <div class="ui-g-6">
        <div [kv-form-element]="{ label: ('customerDetail.other_pet_name'), md: '12'}"></div>
      </div>
      <div class="ui-g-6">
        <input #otherpet data-testid="otherpet" type="number" min="0" pInputText formControlName="other_pet" placeholder="0" />
      </div>
    </div>

    <div class="ui-g-6" [hidden]="otherpet !== undefined && otherpet.value < 1">
      <div class="ui-g-6">
        <div [kv-form-element]="{ label: ('customerDetail.specify'), md: '12'}"></div>
      </div>
      <div class="ui-g-6">
        <input type="text" pInputText formControlName="other_pet_name" />
      </div>
    </div>
  </div>

</form>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/hobbypetinfo/hobbypetinfo.component.html